function openModal(modalId) {
  var modal = document.getElementById(modalId);
  modal.style.display = "flex";
}

function closeModal(modalId) {
  var modal = document.getElementById(modalId);
  modal.style.display = "none";
}

// Close modal when clicking outside of it
window.onclick = function (event) {
  var modal = document.getElementsByClassName("modal");
  if (event.target == modal) {
    modal.style.display = "none";
  }
};

// For WhatsApp modal
function confirmChat(message, number) {
  var whatsappUrl = "https://wa.me/" + number + "?text=" + message;
  window.location.href = whatsappUrl;
}
